// Default labels
const LABELS = {
  leads: {
    plural: 'Customers',
    singular: 'Customer',
  },
  messages: {
    plural: 'Inbox',
    singular: 'Inbox',
  },
  todos: {
    plural: 'Todos',
    singular: 'Todo',
  },
  video: {
    plural: 'Rooms',
    singular: 'Room',
  },
};

export function getLabel(type, isSlug = false, isSingular = false) {
  let label = isSingular ? LABELS[type].singular : LABELS[type].plural;
  return isSlug ? label.toLowerCase().replace(' ', '-') : label;
}
